<template>
    <m-main-layout>
        <div slot="right-btn" v-if="params && (params.showOutput || params.showExport || (params.rightBottons && params.rightBottons.length > 0))">
            <add-button label="导出所有用户" @click.native="output" v-if="params && params.showOutput"></add-button>
            <template v-if="params && params.rightBottons && params.rightBottons.length > 0" v-for="(item,index) in params.rightBottons">
                <base-button :type="item.type" :icon="item.icon" @click.native="toCall(item.path,item.data)">{{item.label}}</base-button>
            </template>
	        <base-button type="primary"  @click.native="toExport(params.exportUrl)" v-if="params && params.showExport">导出数据</base-button>
        </div>

        <div class="margin-bottom">
          <template v-if="params.name!=='冷链专区'">
            <add-button @click.native="$router.push({path:path+'/edit'})" :rule="path+'/edit'" v-if="params.showAdd&& list.length > 0" ></add-button>
          </template>
           <!-- 冷链专区 -->
           <template v-if="params.name==='冷链专区'">
            <add-button label="添加招标" @click.native="$router.push({path:path+'/edit',query:{secondType:'coldBid'}})" :rule="path+'/edit'" v-if="params.showAdd&& list.length > 0" ></add-button>
            <add-button label="添加需求" @click.native="$router.push({path:path+'/edit',query:{secondType:'coldNeed'}})" :rule="path+'/edit'" v-if="params.showAdd&& list.length > 0 "></add-button>
          </template>

        </div>
        <el-row :gutter="10" v-if="params.showSearch">
            <el-form :model="searchForm" label-width="100px" :key="refreshKey" size="small">
                <el-col :span="5" v-for="(item,index) in searchConfig" >
                    <el-form-item :label="item.name" v-if="item.show!=false">
                      <!-- 冷链专区 -->
                        <type-select   v-if="item.type === 'select'" v-model="searchForm[item.value]" @changeCallback="(e)=>changeColdType(searchForm,item.value,e)" @change="(e)=>$set(searchForm,item.value,e)" :options="item.options ? item.options : null" :data="item.data ? item.data : null" :canAdd="false" style="width: 100%;"></type-select>
                        <year-select v-model="searchForm.year" v-else-if="item.value === 'year'" style="width: 100%;"></year-select>
                        <area-select v-model="searchForm[item.value]" v-else-if="item.type === 'area'" style="width: 100%;" :data="item.data"></area-select>
                        <sort-select v-model="searchForm.sort" v-else-if="item.type === 'sort'" style="width: 100%;"></sort-select>
                        <order-type-select v-model="searchForm.order_type" v-else-if="item.type === 'orderType'"></order-type-select>
                        <order-state-select v-model="searchForm.state" v-else-if="item.type === 'orderState'"></order-state-select>
                        <range-time v-model="searchForm[item.value]" v-else-if="item.type ==='timeRange'" style="width: 100%;"></range-time>
                        <el-input v-model="searchForm[item.value]" class="block" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-button size="small" type="primary" @click="toSearch">搜索</el-button>
                    <el-button size="small" type="info" @click="toReset">重置</el-button>
                </el-col>
            </el-form>
        </el-row>
        <div class="bg-light" v-if="list.length > 0">
            <div class="padding bg-gray-3 dark-2 f14">
	            当前合计数量：<b class="brand">{{totalCount}}</b>
							<template v-if="params.showCompanyCount">
								<span style="padding:0 20px;color:#ccc">|</span>
								企业入驻数量：<b class="brand">{{totalCompanyCount}}</b>
							</template>
	            <template v-if="params.showHeji">
		            <span style="padding:0 20px;color:#ccc">|</span>
		            当前合计标的金额：<b class="brand">{{total_bids_price}}万元</b>
		            <template v-if="totals && totals.length > 0">
			            <span style="padding:0 20px;color:#ccc">|</span>
			            当前合计货运总量：
			            <template v-for="(item,index) in totals">
				            <b class="brand">{{item.total_hyzl}}</b>{{item.name}}<span style="padding:0 20px;color:#ccc">|</span>
			            </template>
		            </template>
	            </template>
            </div>
            <el-table
	            size="mini"
                :data="list"
                style="width: 100%" ref="listtable" :fit="true" @selection-change="selectionChange">
                <el-table-column type="selection" width="55" v-if="params.showListDel">
                </el-table-column>
                <template v-for="(item,index) in params['list']['params']">
                    <el-table-column v-if="item.tem" :label="item.name" :width="item.width ? item.width : ''">
                        <template slot-scope="scope">
                            <template v-for="(item2,index2) in item.tem">
                                <div v-if="item2.type === 'copy'">
                                    {{item2.name ? item2.name+'：' : ''}}{{item2.pre ? item2.pre : ''}}{{$utils.evalGet(scope,'scope.row',item2.val)}}<el-button size="mini" @click="copy((item2.pre ? item2.pre : '') + $utils.evalGet(scope,'scope.row',item2.val))" class="margin-left">复制</el-button>
                                </div>
                                <div v-else-if="item2.val === 'title' && (scope.row.is_tuijian === 1 || scope.row.is_toutiao === 1 || scope.row.sort > 0)">
                                    <div class="margin-bottom">
                                        <el-tag size="mini" effect="dark" type="danger" class="margin-right" v-if="scope.row.is_tuijian">推荐</el-tag>
                                        <el-tag size="mini" effect="dark" type="warning" v-if="scope.row.is_toutiao" class="margin-right">头条</el-tag>
                                        <el-tag size="mini" effect="dark" type="success" v-if="scope.row.sort === 3">一级置顶</el-tag>
                                        <el-tag size="mini" effect="dark" type="success" v-if="scope.row.sort === 2">二级置顶</el-tag>
                                        <el-tag size="mini" effect="dark" type="success" v-if="scope.row.sort === 1">三级置顶</el-tag>
                                    </div>
                                    <div>{{item2.name ? item2.name+'：' : ''}}{{item2.pre ? item2.pre : ''}}{{$utils.evalGet(scope,'scope.row',item2.val)}}</div>
                                </div>
                                <div v-else-if="item2.type === 'tag'">
                                    <el-tag v-for="(item,index) in scope.row[item2.val]" class="margin-right hand" @click="copy(item)">{{item}}</el-tag>
                                </div>
                                <div v-else>
                                    {{item2.name ? item2.name+'：' : ''}}{{item2.pre ? item2.pre : ''}}{{$utils.evalGet(scope,'scope.row',item2.val)}}
                                </div>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column v-else-if="item.value === 'title'" :label="item.name" :width="item.width ? item.width : ''">
                        <template slot-scope="scope">
                            <div class="margin-bottom">
                                <el-tag size="mini" effect="dark" type="danger" class="margin-right" v-if="scope.row.is_tuijian">推荐</el-tag>
                                <el-tag size="mini" effect="dark" type="warning" v-if="scope.row.is_toutiao">头条</el-tag>
                            </div>
                            {{scope.row.title}}
                        </template>
                    </el-table-column>
                    <el-table-column v-else-if="item.value === 'applicablePlateNameList'" :label="item.name" :width="item.width ? item.width : ''">
                        <template slot-scope="scope">
                            <div class="margin-bottom">
                                   <el-tag size="mini" v-for="(v,i) in scope.row.applicablePlateNameList" :key="i"  type="info" class="margin-right" >{{v}}</el-tag>
                            </div>
                            {{scope.row.title}}
                        </template>
                    </el-table-column>
                    <template v-else>
                        <el-table-column :label="item.name" :prop="item.value" v-if="item.type === 'state'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'" disable-transitions>{{scope.row.state === 0 ? '禁用' : '可用'}}</el-tag>
                            </template>
                        </el-table-column>
	                    <el-table-column :label="item.name" v-else-if="item.type === 'custom-select'" :width="item.width ? item.width : ''">
		                    <template slot-scope="scope">
			                    <el-tag v-for="(st,si) in item.options" :type="st.color" disable-transitions  v-if="scope.row[item.value] === st.val">{{ st.label }}</el-tag>
		                    </template>
	                    </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'check'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <el-tag type="success" disable-transitions v-if="scope.row.state === 1">审核通过</el-tag>
                                <el-tag type="warning" disable-transitions v-if="scope.row.state === 0">待审核</el-tag>
                                <el-tag type="danger" disable-transitions v-if="scope.row.state === 2">审核不通过</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'bool'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row[item.value] === 1 ? 'success' : 'danger'" disable-transitions>{{scope.row[item.value] === 0 ? '否' : '是'}}</el-tag>
                            </template>
                        </el-table-column>
	                    <el-table-column :label="item.name" v-else-if="item.type === 'for'" :width="item.width ? item.width : ''">
		                    <template slot-scope="scope">
			                    <div v-for="(item2,index2) in scope.row[item.value]">
				                    {{item2[item.data.name]}}
			                    </div>
		                    </template>
	                    </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'percent'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                {{ (scope.row[item.value] * 100).toFixed(2)}}%
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'bids_type'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <div v-if="scope.row[item.value] === 'notice'">招标公告</div>
                                <div v-if="scope.row[item.value] === 'coldChain'">
                                  <div v-if="scope.row['second_type'] === 'coldBid'">冷链招标</div>
                                  <div v-if="scope.row['second_type'] === 'coldNeed'">冷链需求</div>
                                </div>
                                <div v-if="scope.row[item.value] === 'odd'">散单平台</div>
                                <div v-if="scope.row[item.value] === 'storage'">仓储供给</div>
                                <div v-if="scope.row[item.value] === 'device'">设备采购</div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'image'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <el-image
                                    style="height: 60px"
                                    :src="scope.row[item.value].indexOf('http')>= 0 ? scope.row[item.value] : $config.assetsUrl + scope.row[item.value]"
                                    :preview-src-list="scope.row[item.value].indexOf('http')>= 0 ? [scope.row[item.value]] : [$config.assetsUrl + scope.row[item.value]]" v-if="scope.row[item.value]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'totime'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <div v-if="scope.row.time_type === 'day'">{{scope.row.to_time}}天</div>
                                <div v-if="scope.row.time_type === 'week'">{{scope.row.to_time}}周</div>
                                <div v-if="scope.row.time_type === 'month'">{{scope.row.to_time}}月</div>
                                <div v-if="scope.row.time_type === 'year'">{{scope.row.to_time}}年</div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'orderState'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <div v-if="scope.row.state === 1">待支付</div>
                                <div v-if="scope.row.state === 2">已支付</div>
                            </template>
                        </el-table-column>
	                    <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'options'" :width="item.width ? item.width : ''">
		                    <template slot-scope="scope">
			                    <template v-for="(t,i) in item.options">
				                    <span v-if="$utils.evalGet(scope,'scope.row',item.value) === t.value">{{ t.label }}</span>
			                    </template>
		                    </template>
	                    </el-table-column>
	                    <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'changeStatus'" :width="item.width ? item.width : ''">
		                    <template slot-scope="scope">
			                    <el-switch
				                    v-model="scope.row[item.value]"
				                    active-color="#13ce66"
				                    :active-value="1"
				                    :inactive-value="0"
				                    @change="changeStatus(scope.row[params.pk ? params.pk : 'id'],scope.row,item)">
			                    </el-switch>
		                    </template>
	                    </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'payType'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <div v-if="scope.row.pay_type === 'weixin'">微信</div>
                                <div v-if="scope.row.pay_type === 'alipay'">支付宝</div>
                                <div v-if="scope.row.pay_type === 'mini'">微信小程序</div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'orderType'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <div v-if="scope.row.order_type === 'vip'">购买VIP</div>
                                <div v-if="scope.row.order_type === 'bids'">购买标讯</div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'time'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                {{scope.row[item.value] > 0 ? $moment.unix(scope.row[item.value]).format('YYYY-MM-DD HH:mm:ss') : '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" v-else-if="item.type === 'link'" :width="item.width ? item.width : ''">
                            <template slot-scope="scope">
                                <a :href="item.linkUrl ? item.linkUrl+scope.row[item.value] : scope.row[item.value]" :target="item.target ? item.target : '_blank'">{{scope.row[item.value]}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column :label="item.name" :prop="item.value" :width="item.width ? item.width : ''" v-else></el-table-column>
                    </template>
                </template>
                <el-table-column fixed="right" align="right" label="操作" :width="params.optionsWidth ? params.optionsWidth : (params.showDetail ? 300 : 200)" v-if="params.showAdd || params.showEdit || params.showDel || params.showDetail">
                    <template slot-scope="scope">
                        <base-button plain type="success" @click.native="changeState(scope.row.id,1)" v-if="params.showCheck && scope.row.state === 0" :rule="params.checkRouter">审核</base-button>
                        <base-button plain type="danger" @click.native="changeState(scope.row.id,0)" v-if="params.showCheck && scope.row.state === 1" :rule="params.checkRouter">反审核</base-button>
                        <base-button @click.native="$router.push({path:params.detailRouter,query:{id:scope.row.id }})" :rule="params.detailRouter" v-if="params.showDetail">{{params.detailText ? params.detailText : '详情'}}</base-button>
                        <edit-button @click.native="$router.push({ path:params.editRouter,query:{id:scope.row.id,pageType:scope.row.type, rowData:scope.row }})" v-if="params.showEdit" :rule="params.editRouter"></edit-button>
                        <del-button @click.native="del(scope.row)" :rule="params.delRouter" v-if="params.showDel"></del-button>
	                    <base-button plain @click.native="toDiy(scope.row)" v-if="params.showDiy">{{params.diyLabel ? params.diyLabel : '自定义按钮'}}</base-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="margin-top" v-if="params.showListDel || params.showListTuijian || params.showListToutiao">
                <base-button @click.native="selectAll" :rule="params.delRouter">全选</base-button>
                <del-button @click.native="listDel" :rule="params.delRouter" label="批量删除" v-if="params.showListDel"></del-button>
                <base-button icon="el-icon-close-notification" type="danger" @click.native="listChangeState('is_tuijian','推荐')" :rule="params.editRouter" v-if="params.showListTuijian">批量取消推荐</base-button>
                <base-button icon="el-icon-close-notification" type="primary" @click.native="listChangeState('is_toutiao','头条')" :rule="params.editRouter" v-if="params.showListToutiao">批量取消头条</base-button>
                <base-button icon="el-icon-close-notification" type="success" @click.native="listChangeState('sort','置顶')" :rule="params.editRouter" v-if="params.showListSort">批量取消置顶</base-button>
                <base-button icon="el-icon-close-notification" type="primary" plain @click.native="listChangeState('state','审核')" :rule="params.checkRouter" v-if="params.showListState">批量重置审核</base-button>
            </div>
            <div class="padding-top-bottom-20 text-center" v-if="$utils.isUndefined(params.showPage) ? true : params.showPage">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :page-size="searchForm.pageSize"
                    :current-page.sync="searchForm.page"
                    :total="totalCount"
                    @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
        <div class="padding-top-bottom-40 border-top text-center dark-2" v-else>
            暂无数据，<add-button @click.native="$router.push({path:params.editRouter})" :rule="params.editRouter" v-if="params.showAdd"></add-button>
        </div>
        <el-dialog title="导出" center width="500px" :visible.sync="showOutputReset">
            <div v-if="outputData && outputData.last_time">
                <el-button class="block" icon="el-icon-download" size="medium" type="primary" @click="download($config.assetsUrl+outputData.url)" v-if="outputData.last_time">直接下载({{outputData.last_time}})</el-button>
            </div>
            <div class="margin-top">
                <el-form :model="outForm" label-width="100px">
                    <el-form-item label="注册时间">
                        <range-time v-model="outForm.create_time" style="width: 100%;" @change="changeOutTime"></range-time>
                    </el-form-item>
                    <el-form-item label="预计导出数量">
                        {{outCount}}
                    </el-form-item>
                    <el-form-item label="导出字段">
                        <el-checkbox-group v-model="outForm.items">
	                        <el-checkbox label="user_type">用户类型</el-checkbox>
	                        <el-checkbox label="gys_type">供应商类型</el-checkbox>
                          <el-checkbox label="create_time">注册时间</el-checkbox>
                          <el-checkbox label="name">姓名</el-checkbox>
                          <el-checkbox label="mobile">手机号</el-checkbox>
                          <el-checkbox label="email">邮箱</el-checkbox>
                          <el-checkbox label="company">公司</el-checkbox>
                          <el-checkbox label="job">职位</el-checkbox>
                          <el-checkbox label="vip">VIP</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </div>
            <div class="margin-top">
                <el-button class="block" icon="el-icon-refresh-right" size="medium" type="warning" @click="reMark">重新生成(等待5分钟后再下载)</el-button>
            </div>
        </el-dialog>
    </m-main-layout>
</template>

<script>
export default {
    name: "PolicyList",
    data() {
        return {
            refreshKey:new Date().getTime(),
            outputData:null,
            showOutputReset:false,
            path:'',
            params:null,
            totalCount: 0,
					totalCompanyCount:0,
            list: [],
	        total_bids_price:0,
	        totals:null,
            searchConfig:[],
            searchForm: {
                pageSize:15,
                page:1,
            },
            listData:null,
            addTotal:{},
            addTotalType:false,
            rules: {},
            time:null,
            loading:null,
            ids:[],
            outForm:{
                create_time:'',
                items:['user_type','gys_type',"create_time","name", "mobile", "email", "company", "job", "vip"]
            },
            outCount:0
        };
    },
    created() {
        let _config = window.config.paths();
        this.path = this.$route.path;
        this.params = _config[this.path];
        this.searchConfig = this.params['search']['params']
        this.listData = this.params.listData ? this.params.listData : {};
        if(this.params.showSearch) {
            let _edit =  this.searchConfig ;
            for (let i = 0; i < _edit.length; i++) {
                if(_edit[i].type === 'timeRange'){
                    this.$set(this.searchForm, _edit[i].value, '');
                }else {
                    this.$set(this.searchForm, _edit[i].value, '');
                }
            }
        }

        this.searchForm = this.$route.query ? {...this.searchForm,...this.$route.query} : {...this.searchForm};
        this.searchForm.page = parseInt(this.searchForm.page);
        this.searchForm.pageSize = parseInt(this.searchForm.pageSize);
        this.searchForm.sort = this.searchForm.sort ? parseInt(this.searchForm.sort) : '';
        if(this.params.name=='冷链专区'){
          if(this.searchForm.second_type=='coldNeed'){
              this.searchConfig[13].show=true
          }
        }
    },
    mounted() {
        this.getList();

    },
    methods: {
	    toExport(url){
		    let _this = this;

		    if (url) {
			    let _datas = this.searchForm ? JSON.parse(JSON.stringify({...this.searchForm,...this.listData})) : {};
			    delete _datas.pageSize;
			    // delete _datas.pageNum;

			    this.$http.httpPost({
				    url: url,
				    datas: _datas,
				    showLoad:true,
				    download: true,
				    success(res) {
					    const blob = new Blob([res]) // 构造一个blob对象来处理数据
					    const fileName = (_this.params.exportFileName ? _this.params.exportFileName : '导出数据') + '_' + _this.$moment().format('YYYYMMDDHHmmss') + '.xlsx';

					    // console.log(fileName);

					    const link = document.createElement('a') // 创建a标签
					    link.download = fileName // a标签添加属性
					    link.style.display = 'none'
					    link.href = URL.createObjectURL(blob)
					    document.body.appendChild(link)
					    link.click();
					    URL.revokeObjectURL(link.href);
					    document.body.removeChild(link);
				    }
			    });
		    }
	    },
	    //改变状态
	    changeStatus(index, row,option) {

		    // console.log(option);
		    // console.log(row.state);

		    let _this = this;
		    let _text = '';
		    let _status = '';
		    let flag = option.comProp && !this.$utils.isUndefined(option.comProp.key) ? row[option.comProp.key] : option.value;

		    if (row[option.comProp && option.comProp.key ? option.comProp.key : option.value] === 0 || row[option.comProp && option.comProp.key ? option.comProp.key : option.value] === 1) {
			    if (row[option.comProp && option.comProp.key ? option.comProp.key : option.value] === 1) {
				    _text = option && option.comProp && option.comProp.successTitle ? option.comProp.successTitle : '是否【启用】该条数据？';
				    _status = 1;
			    } else if (row[option.comProp && option.comProp.key ? option.comProp.key : option.value] === 0) {
				    // console.log('===f=ds');
				    // console.log(option.comProp);
				    _text = option && option.comProp && option.comProp.cancelTitle ? option.comProp.cancelTitle : '是否【禁用】该条数据？';
				    _status = 0;
			    }
			    this.$confirm(_text, "提示", {
				    confirmButtonText: "确定",
				    cancelButtonText: "取消",
				    type: "warning"
			    })
				    .then(() => {
					    if (_status === 0 || _status === 1) {
						    if ((option.comProp && option.comProp.statusUrl) || _this.listOptions.statusUrl) {
							    let _id = row[_this.params.pk ? _this.params.pk : 'id'];

							    this.$http.httpPost({
								    url: (option.comProp && option.comProp.statusUrl) ? option.comProp.statusUrl.replace('{id}', _id) : _this.params.list.options.statusUrl.replace('{id}', _id),
								    datas: {
									    [_this.params.pk ? _this.params.pk : 'id']: _id,
									    [option.comProp && option.comProp.key ? option.comProp.key : 'state']: _status
								    },
								    method:option.comProp && option.comProp.method ? option.comProp.method : 'post',
								    success(res) {
									    _this.$utils.success("操作成功！");
									    _this.getList();
								    },
								    fail(err){
									    if (flag === 1) {
										    row[option.comProp && option.comProp.key ? option.comProp.key : option.value] = 0;
									    } else {
										    row[option.comProp && option.comProp.key ? option.comProp.key : option.value] = 1;
									    }
									    _this.$utils.error(err.msg);
								    }
							    });
						    }
					    }
				    })
				    .catch((err) => {
					    // console.log(err);
					    if (flag === 1) {
						    row[option.comProp && option.comProp.key ? option.comProp.key : option.value] = 0;
					    } else {
						    row[option.comProp && option.comProp.key ? option.comProp.key : option.value] = 1;
					    }
				    });
		    } else {
			    this.$utils.warning('操作异常');
		    }
	    },
        copy(txt){
          debugger;
            console.log(txt);
            let _this = this;
            this.$copyText(txt).then(function (e) {
                _this.$utils.success('复制成功');
            }, function (e) {

            })
        },
        toSearch() {
            for(let i in this.searchForm){
                if(i.endsWith('_time')){
                    console.log(i);
                }
            }
            this.searchForm.page = 1
            this.$router.replace({query:{...this.searchForm}});
        },
        toReset(){
            let _edit = this.params['search']['params'];

            for(let i = 0;i < _edit.length;i++){
                this.$set(this.searchForm, _edit[i].value, '');
            }

            this.$router.replace({query:{...this.searchForm}});
        },
	    getList() {
		    let _this = this;
		    let url = this.params.apiUrl+'/listPage';
		    let params = {..._this.searchForm,...this.listData};
		    if(this.params.name=='行业管理'){
			    url = '/industryCategory/getIndustryCategoryPageList';
			    params={
					    pageSize:this.searchForm.pageSize,
					    page:this.searchForm.page
			    }
		    }
		    this.$http.httpPost({
			    url: url,
			    datas: params,
			    success(res) {
						// console.log(res);
				    _this.list = res.list ? res.list : [];
				    _this.totalCount = Number(res.totalCount);
						_this.totalCompanyCount = res.totalCompanyCount ? res.totalCompanyCount : 0;

						if(_this.params.showHeji) {
							if (res.total_bids_price) {
								_this.total_bids_price = res.total_bids_price;
							}

							if (res.totals) {
								_this.totals = res.totals;
							}
						}
			    }
		    });
	    },
        // getList() {
        //   let _this = this;
        //   let url = this.params.apiUrl+'/listPage';
        //   let params = {..._this.searchForm,...this.listData};
        //   let type=""
        //   if(this.params.name=='行业管理'){
        //     url = '/admin/industryCategory/getIndustryCategoryPageList';
        //     params={
        //       pageParamVO:{
        //         pageSize:this.searchForm.pageSize,
        //         page:this.searchForm.page
        //       }
        //     }
        //     type='json'
        //   }
        //     this.$http.httpPost({
        //         url: url,
        //         datas: params,
        //         type:type,
        //         success(res) {
        //             _this.list = res.list ? res.list : [];
        //             _this.totalCount = Number(res.totalCount);
        //         }
        //     });
        // },
        pageChange(page) {
            this.searchForm.page = page;
            this.$router.replace({query:{...this.searchForm}});
        },
        // del(row) {
        //     let _this = this;
        //     let url = _this.params.apiUrl + '/del';
        //     let params = {id:row.id};
        //     let type=""
        //     if(this.params.name=='行业管理'){
        //       url = '/admin/industryCategory/deleteIndustryCategory';
        //       params={industryCategoryId:row.industryCategoryId}
        //       type='json'
        //     }
        //     this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning"
        //     })
        //         .then(() => {
        //             this.$http.httpPost({
        //                 url: url,
        //                 datas: params,
        //                 type:type,
        //                 success(res) {
        //                     _this.$utils.success("删除成功！");
        //                     _this.getList();
        //                 }
        //             });
        //         })
        //         .catch(() => {
        //             // _this.$utils.warning('取消了');
        //         });
        // },
	    toDiy(row){
				this.params.doDiy(row,this);
	    },
	    del(row) {
		    let _this = this;
		    let url = _this.params.apiUrl + '/del';
		    let params = {id:row.id};
		    if(this.params.name=='行业管理'){
			    url = '/industryCategory/deleteIndustryCategory';
			    params={industryCategoryId:row.industryCategoryId}
		    }
		    this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
			    confirmButtonText: "确定",
			    cancelButtonText: "取消",
			    type: "warning"
		    })
			    .then(() => {
				    this.$http.httpPost({
					    url: url,
					    datas: params,
					    success(res) {
						    _this.$utils.success("删除成功！");
						    _this.getList();
					    }
				    });
			    })
			    .catch(() => {
				    // _this.$utils.warning('取消了');
			    });
	    },
        output(){
            let _this = this;

            this.$http.httpPost({
                url: _this.params.apiUrl + '/getOutPut',
                datas: null,
                success(res) {
                    _this.outputData = res;
                    _this.showOutputReset = true;

                    _this.getOutCount();
                }
            });
        },
        reMark(){
            let _this = this;
            this.$http.httpPost({
                url: _this.params.apiUrl + '/remark',
                datas: this.outForm,
                success(res) {
                    _this.$utils.success('执行成功，请等待5分钟后再次点击导出按钮即可下载');
                    _this.showOutputReset = false;
                }
            });
        },
        changeOutTime(){
            this.getOutCount();
        },
        getOutCount(){
            let _this = this;
            this.$http.httpPost({
                url:_this.params.apiUrl + '/getOutPutCount',
                datas:this.outForm,
                success(res){
                    _this.outCount = res.count;
                }
            })
        },
        download(url){
            window.open(url, '_blank');
            this.showOutputReset = false;
        },
        selectAll(){
            this.$refs.listtable.toggleAllSelection();
        },
        selectionChange(val){
            let _check = [];
            if(val.length > 0){
                for(let i =0; i < val.length;i++){
                    _check.push(val[i].id);
                }
            }

            this.ids = _check;
        },
        listChangeState(type,text){
            let _this = this;
            if(this.ids.length > 0) {
                this.$confirm('是否批量改变'+this.ids.length+'条数据的'+text+'状态?', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let _datas = {};

                        _datas[type] = 0;

                        this.$http.httpPost({
                            url: _this.params.apiUrl + '/allEdit',
                            datas: {id: [this.ids, 'in'],..._datas},
                            success(res) {
                                _this.$utils.success("操作成功！");
                                _this.getList();
                            }
                        });
                    })
                    .catch(() => {
                        // _this.$utils.warning('取消了');
                    });
            }else{
                this.$utils.warning('请选择要操作的数据');
            }
        },
        changeState(id,state){
            let _this = this;
            let _text = '';
            if(id && state >= 0) {
                if(state === 0){
                    _text = '是否恢复该条数据的审核状态为【待审核】？'
                }else if(state === 1){
                    _text = '是否【审核通过】该条数据？'
                }
                this.$confirm(_text, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$http.httpPost({
                            url: _this.params.apiUrl + '/changeState',
                            datas: {id: id,state:state},
                            success(res) {
                                _this.$utils.success("操作成功！");
                                _this.getList();
                            }
                        });
                    })
                    .catch(() => {
                        // _this.$utils.warning('取消了');
                    });
            }else{
                this.$utils.warning('操作异常');
            }
        },
        listDel() {
            let _this = this;
            if(this.ids.length > 0) {
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$http.httpPost({
                            url: _this.params.apiUrl + '/del',
                            datas: {id: [this.ids, 'in']},
                            success(res) {
                                _this.$utils.success("删除成功！");
                                _this.getList();
                            }
                        });
                    })
                    .catch(() => {
                        // _this.$utils.warning('取消了');
                    });
            }else{
                this.$utils.warning('请选择要删除的数据');
            }
        },
        toCall(path,data){
            let _this = this;
            if(path && data) {
                this.$http.httpPost({
                    url: path,
                    datas: data,
                    success(res) {
                        _this.$utils.success("操作成功！");
                    }
                });
            }else{
                this.$utils.warning('无法操作');
            }
        },
        // 冷链专区查询条件联动
        changeColdType(searchForm,val,e){
          // 冷链专区，选择分类为冷链招标，隐藏类型下拉框，否则展示类型下拉框
          if(this.params.name=='冷链专区'&& val=='second_type'){
            this.searchForm.type_demand_id=""
            if(e==='coldNeed'){
              this.searchConfig[13].show=true
              this.refreshKey=new Date().getTime()
            }else{
              this.searchConfig[13].show=false
              this.refreshKey=new Date().getTime()

            }
          }

        },
    },
    destroyed() {
        if(this.time) {
            clearInterval(this.time);
            this.time = null;
        }
    }
};
</script>
